/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiPageResponseMaintenanceNotificationResponseVoid } from '../models/ApiPageResponseMaintenanceNotificationResponseVoid';
import type { ApiResponseListMaintenanceNotificationWithRecordResponse } from '../models/ApiResponseListMaintenanceNotificationWithRecordResponse';
import type { ApiResponseListRecordsGroupByDate } from '../models/ApiResponseListRecordsGroupByDate';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { Pageable } from '../models/Pageable';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MaintenanceNotificationControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 소모품 이력 알림 업데이트
   * 소모품 이력 알림 상태를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateNotification2({
    vin,
    notificationId,
    action,
  }: {
    vin: string,
    notificationId: number,
    action: 'KEEP_BOTH' | 'KEEP_NEW_RECORD' | 'KEEP_EXIST_RECORD' | 'PENDING_DECISION' | 'RECORD_ADDED',
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/notifications/{notificationId}/action/{action}',
      path: {
        'vin': vin,
        'notificationId': notificationId,
        'action': action,
      },
    });
  }
  /**
   * 소모품 이력 알림 목록 조회 (페이징)
   * 소모품 이력 알림 목록을 조회합니다.
   * @returns ApiPageResponseMaintenanceNotificationResponseVoid OK
   * @throws ApiError
   */
  public getNotifications2({
    vin,
    pageable,
    puid,
    sestCode,
    type,
    status,
    dataSource,
    startDate,
    endDate,
  }: {
    vin: string,
    pageable: Pageable,
    puid?: string,
    sestCode?: string,
    type?: 'NEW_RECORD' | 'KEEP_RECORD' | 'COMPARISON',
    status?: 'UNREAD' | 'READ' | 'PROCESSED',
    dataSource?: 'SERVICE_CENTER' | 'USER' | 'ADMIN',
    startDate?: string,
    endDate?: string,
  }): CancelablePromise<ApiPageResponseMaintenanceNotificationResponseVoid> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/notifications',
      path: {
        'vin': vin,
      },
      query: {
        'puid': puid,
        'sestCode': sestCode,
        'type': type,
        'status': status,
        'dataSource': dataSource,
        'startDate': startDate,
        'endDate': endDate,
        'pageable': pageable,
      },
    });
  }
  /**
   * 읽지 않은 소모품 이력 알림 목록 조회 (유저 등록)
   * 읽지 않은 소모품 이력 알림 목록을 조회합니다.
   * @returns ApiResponseListMaintenanceNotificationWithRecordResponse OK
   * @throws ApiError
   */
  public getUnreadUserNotifications({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListMaintenanceNotificationWithRecordResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/notifications/user/unread',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 읽지 않은 소모품 이력 알림 목록 조회 (서비스 센터 등록)
   * 읽지 않은 소모품 이력 알림 목록을 조회합니다.
   * @returns ApiResponseListRecordsGroupByDate OK
   * @throws ApiError
   */
  public getUnreadServiceCenterNotifications({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListRecordsGroupByDate> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/notifications/service-center/unread',
      path: {
        'vin': vin,
      },
    });
  }
}
